/* dl-collection.js — full-row trimming, infinite "Načíst další", Filtry panel.

   2026-08-22b (Hynek) — FULL-WIDTH PANEL. The 400px right-hand drawer with
   collapsible groups is gone. Filters now open as a panel under the toolbar that
   pushes the grid down, every option visible at once, laid out in as many columns
   as fit (CSS columns, so the groups pack rather than align to a ragged row).
   No accordions, no scrim, no body scroll lock, no viewport geometry to measure —
   the panel is in normal flow, so it can never be clipped by the header or by the
   Shopify preview bar, which is what the old drawer kept fighting.

   2026-08-22 (Hynek) — DEFERRED APPLY:
   · Nothing reloads on a tick any more. Every choice (checkbox, swatch, CCT
     slider, price) is staged locally; the red footer button commits them in a
     single navigation and the panel closes with the page.
   · The footer button carries the live result count ("Zobrazit 37 produktů").
     After each change we fetch the pending URL as a bare section render
     (?section_id=…) and read back both the total and the per-option counts,
     so counts stay honest while the selection is being built.
   · Closing the panel (X / Esc / the Filtry button again) discards unapplied
     changes and puts it back to what the grid is actually showing.

   2026-08-03 drawer upgrades: swatch chips, CCT gradient slider, live price.
   Rollback = assets/dl-collection-js-backup-20260822b.txt (this file's
   predecessor) or assets/dl-collection-js-backup-20260822.txt (older). */
(function(){
const $=(s,e=document)=>e.querySelector(s), $$=(s,e=document)=>[...e.querySelectorAll(s)];
const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
const root=$("#dl-collection"); if(!root) return;
const grid=$("#dl-grid");
const cols=()=>getComputedStyle(grid).gridTemplateColumns.split(" ").length;

/* --- keep the last visible row complete --- */
function trim(){
  const cards=$$(".pcard",grid);
  cards.forEach(c=>c.hidden=false);
  const hasMore=!!$(".more .dl-more",root);   // re-read: load-more may have removed it
  const c=cols();
  if(hasMore && c>1){
    const rem=cards.length%c;
    // never hide so much that fewer than one full row remains
    if(rem && cards.length-rem>=c) cards.slice(cards.length-rem).forEach(x=>x.hidden=true);
  }
  const shown=cards.filter(x=>!x.hidden).length;
  const el=$("#dl-shown"); if(el) el.textContent=shown;
}
trim();
let rt=null,last=cols();
addEventListener("resize",()=>{clearTimeout(rt);rt=setTimeout(()=>{const c=cols();if(c!==last){last=c;trim();}},120)});

/* --- load more (appends, keeps rows full) --- */
async function loadMore(link){
  const btn=$("button",link); btn.textContent="Načítám…";
  const html=await (await fetch(link.href)).text();
  const doc=new DOMParser().parseFromString(html,"text/html");
  doc.querySelectorAll("#dl-grid .pcard").forEach(c=>grid.appendChild(c));
  const next=doc.querySelector(".more .dl-more");
  if(next){ link.href=next.href; btn.textContent=next.querySelector("button").textContent; }
  else { link.closest(".more").remove(); }
  history.replaceState(null,"",link.href.replace(/([?&])page=\d+/,"$1page=1"));
  trim();
}
document.addEventListener("click",e=>{
  const link=e.target.closest(".dl-more"); if(!link) return;
  e.preventDefault(); loadMore(link);
});

/* --- sort --- */
$("#dl-sort")?.addEventListener("change",e=>{
  const u=new URL(location.href); u.searchParams.set("sort_by",e.target.value); u.searchParams.delete("page");
  location.href=u.toString();
});

/* --- Filtry panel, driven by Search & Discovery data --- */
const data=JSON.parse($("#dl-filter-data")?.textContent||"[]");
if(!data.length) return;

/* Shopify hands back filter *values* HTML-escaped ("Santa &amp; Cole") while the
   label is clean. We build URLs from the value, so decode it once, here. */
const unesc=s=>{ if(String(s).indexOf("&")<0) return String(s); const t=document.createElement("textarea"); t.innerHTML=String(s); return t.value; };
data.forEach(g=>{ (g.values||[]).forEach(v=>{ if(v.v!=null) v.v=unesc(v.v); }); });

/* 2026-10-09 case duplicates: product data spells some values two ways
   ("Bílá" / "bílá"), and S&D lists each spelling as its own value, so the
   drawer showed two chips that each found part of the products. They merge
   into one chip that stages every spelling (OR within a group, so the grid
   gets the union). The first spelling stays the chip's data-v; ALIAS maps it
   to all spellings, PRIMARY maps each spelling back. The merged count is the
   sum, which can overstate by products carrying both spellings; live counts
   after a click come from the server. The CCT slider is left alone. */
const ALIAS={}, PRIMARY={};
data.forEach(g=>{
  if(g.type==="price_range"||!g.values||/barevna_teplota/.test(g.param||"")) return;
  const by=new Map(), out=[];
  g.values.forEach(v=>{
    const k=String(v.l).trim().toLowerCase().replace(/\s+/g," ");
    const m=by.get(k);
    if(!m){ v.raws=[String(v.v)]; v.on=v.active?[String(v.v)]:[]; by.set(k,v); out.push(v); return; }
    m.raws.push(String(v.v)); m.c+=v.c; m.active=m.active||v.active;
    if(v.active) m.on.push(String(v.v));          // seed() restores every applied spelling
    if(!m.sw&&!m.swi){ m.sw=v.sw; m.swi=v.swi; }
    if(/^\p{Ll}/u.test(m.l)&&/^\p{Lu}/u.test(v.l)) m.l=v.l;   // "Bílá" reads better than "bílá"
  });
  g.values=out;
  out.forEach(v=>{
    if(v.raws.length<2) return;
    (ALIAS[g.param]=ALIAS[g.param]||{})[v.raws[0]]=v.raws;
    const pm=PRIMARY[g.param]=PRIMARY[g.param]||{};
    v.raws.forEach(r=>{ pm[r]=v.raws[0]; });
  });
});
const rawsOf=(p,v)=>(ALIAS[p]&&ALIAS[p][String(v)])||[String(v)];
const chipCount=(p,s)=>{ const pm=PRIMARY[p]; return pm?new Set([...s].map(r=>pm[r]||r)).size:s.size; };

const secWrap=root.closest('[id^="shopify-section-"]');
const SECTION=secWrap?secWrap.id.replace("shopify-section-",""):null;
const APPLIED_TOTAL=parseInt(root.dataset.total,10);

/* CCT colour ramp — same anchors as sections/dl-cct-slider.liquid, white point 4000 K */
const CCT_ANCHORS=[[1000,[233,76,34]],[1200,[236,82,36]],[1300,[240,96,38]],[1600,[252,138,42]],[1800,[255,168,58]],[1900,[255,178,68]],[2000,[255,190,82]],[2200,[255,205,108]],[2400,[255,222,140]],[2500,[255,236,178]],[2700,[255,248,228]],[3000,[255,255,255]],[4000,[255,255,255]],[5000,[224,234,251]],[10000,[188,213,250]]];
function cctColor(k){
  const A=CCT_ANCHORS;
  if(k<=A[0][0]) return "rgb("+A[0][1].join(",")+")";
  if(k>=A[A.length-1][0]) return "rgb("+A[A.length-1][1].join(",")+")";
  for(let i=0;i<A.length-1;i++){
    const lo=A[i],hi=A[i+1];
    if(k>=lo[0]&&k<=hi[0]){
      const t=hi[0]===lo[0]?0:(k-lo[0])/(hi[0]-lo[0]);
      const c=[0,1,2].map(j=>Math.round(lo[1][j]+(hi[1][j]-lo[1][j])*t));
      return "rgb("+c.join(",")+")";
    }
  }
  return "rgb(255,255,255)";
}
const kelvinOf=v=>{const n=parseInt(String(v).replace(/[^0-9]/g,""),10);return isNaN(n)?null:n};
const isCct=g=>/barevna_teplota/.test(g.param||"");
const hasSwatches=g=>g.values&&g.values.some(v=>v.sw||v.swi);

/* ============================================================
   staged selection — nothing navigates until Zobrazit
   ============================================================ */
const PRICE=data.find(g=>g.type==="price_range")||null;
const sel=new Map();                       // param -> Set(raw values)
let price={gte:"",lte:""};
const resetters=[];                        // back to what the grid is showing
const clearers=[];                         // back to "no filter at all"

function seed(){
  sel.clear();
  data.forEach(g=>{
    if(g.type==="price_range") return;
    const on=(g.values||[]).flatMap(v=>v.on||(v.active?[String(v.v)]:[]));
    if(on.length) sel.set(g.param,new Set(on));
  });
  price={gte:PRICE&&PRICE.min?String(PRICE.min):"",lte:PRICE&&PRICE.max?String(PRICE.max):""};
}
seed();

const setOf=p=>{let s=sel.get(p); if(!s){s=new Set();sel.set(p,s);} return s};
const isOn=(p,v)=>{const s=sel.get(p);return !!(s&&rawsOf(p,v).some(r=>s.has(r)))};

/* pending query string, built from scratch: every filter.* param is dropped
   and re-emitted from the staged state, so nothing can leak in from the URL */
function buildQS(){
  const sp=new URLSearchParams(location.search);
  [...sp.keys()].forEach(k=>{ if(k.indexOf("filter.")===0) sp.delete(k); });
  sp.delete("page");
  sel.forEach((vals,param)=>{ [...vals].forEach(v=>sp.append(param,v)); });
  if(PRICE){
    if(price.gte) sp.set(PRICE.param+".gte",price.gte);
    if(price.lte) sp.set(PRICE.param+".lte",price.lte);
  }
  return sp.toString();
}
const canon=qs=>[...new URLSearchParams(qs)].map(p=>p[0]+"="+p[1]).sort().join("&");
const APPLIED_QS=(()=>{const sp=new URLSearchParams(location.search);sp.delete("page");return canon(sp.toString())})();
const dirty=()=>canon(buildQS())!==APPLIED_QS;

/* how many filters the customer has staged (a CCT range counts as one) */
function stagedCount(){
  let n=0;
  data.forEach(g=>{
    if(g.type==="price_range") return;
    const s=sel.get(g.param); if(!s||!s.size) return;
    n+= isCct(g) ? (s.size===g.values.length?0:1) : chipCount(g.param,s);
  });
  if(price.gte||price.lte) n++;
  return n;
}
const plural=n=>n===1?"produkt":(n>=2&&n<=4?"produkty":"produktů");

/* ---------------- panel markup ----------------
   2026-08-22: the 400px right-hand drawer with collapsible groups is gone. The
   filters are now a full-width panel that opens under the toolbar and pushes the
   grid down, with every option visible at once in as many columns as fit. No
   accordions: nothing is one click away from being seen. */
const dr=document.createElement("div"); dr.className="fpanel"; dr.id="dl-fpanel";
dr.innerHTML='<div class="fpin"><div class="fwrap"><div class="fphead"><span class="lb">Filtry</span><button class="x dl-x" type="button" aria-label="Zavřít"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="square" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div><div class="fcols"></div></div><div class="ffoot"><button class="clr" type="button">Zrušit vše</button><button class="go" type="button">Zobrazit produkty</button></div></div>';
$(".fcols",dr).innerHTML=data.map((g,i)=>{
  let body;
  if(g.type==="price_range"){
    const ph=g.rangeMax?("do "+g.rangeMax):"do";
    body='<div class="fprice"><input type="number" inputmode="numeric" name="'+esc(g.param)+'.gte" placeholder="od"'+(g.min?' value="'+g.min+'"':'')+'><span class="dash">–</span><input type="number" inputmode="numeric" name="'+esc(g.param)+'.lte" placeholder="'+esc(ph)+'"'+(g.max?' value="'+g.max+'"':'')+'></div>';
  } else if(isCct(g)&&g.values.filter(v=>kelvinOf(v.v||v.l)!=null).length>=2){
    body='<div class="cct" data-cct="'+i+'"></div>';
  } else if(hasSwatches(g)){
    body='<div class="fswrap">'+g.values.map(v=>{
      const chip=v.swi?'background-image:url('+esc(v.swi)+')':'background:'+esc(v.sw||"#ddd");
      return '<a class="fsw'+(v.active?" on":"")+'" href="'+v.u+'" data-p="'+esc(g.param)+'" data-v="'+esc(v.v)+'" title="'+esc(v.l)+'"><span class="swc" style="'+chip+'"></span><span class="n">'+esc(v.l)+'</span><span class="c">'+v.c+'</span></a>';
    }).join("")+'</div>';
  } else {
    body=g.values.map(v=>'<a class="fopt'+(v.active?" on":"")+'" href="'+v.u+'" data-p="'+esc(g.param)+'" data-v="'+esc(v.v)+'"><span class="cb"><svg class="ic" viewBox="0 0 24 24"><path d="m5 13 4 4 10-10"></path></svg></span><span class="n">'+esc(v.l)+'</span><span class="c">'+v.c+'</span></a>').join("");
  }
  return '<div class="fgrp" data-grp="'+i+'"><div class="gh">'+esc(g.label)+'<span class="gn"></span></div><div class="gb">'+body+'</div></div>';
}).join("");
/* in flow, right after the toolbar — the grid moves down, nothing is covered */
const tbar=$(".tbar",root);
if(tbar) tbar.insertAdjacentElement("afterend",dr); else root.insertBefore(dr,root.firstChild);

const foot=$(".ffoot",dr), go=$(".go",dr);

/* ---------------- live counts ---------------- */
let seq=0, timer=null;
function setGo(total){
  if(total==null||isNaN(total)){ go.textContent="Zobrazit produkty"; go.classList.remove("zero"); return; }
  go.classList.toggle("zero",total===0);
  go.textContent = total===0 ? "Žádné produkty" : ("Zobrazit "+total+" "+plural(total));
}
function paintCounts(groups){
  const byParam={}; groups.forEach(g=>{ byParam[g.param]=g; });
  data.forEach(g=>{
    const fresh=byParam[g.param]; if(!fresh||g.type==="price_range") return;
    const map={}; (fresh.values||[]).forEach(v=>{ map[unesc(v.v)]=v.c; });
    $$('[data-p="'+(window.CSS&&CSS.escape?CSS.escape(g.param):g.param)+'"]',dr).forEach(el=>{
      const rs=rawsOf(el.dataset.p,el.dataset.v).filter(r=>map[r]!=null);
      const c=rs.length?rs.reduce((a,r)=>a+map[r],0):null;
      const slot=$(".c",el); if(slot&&c!=null) slot.textContent=c;
      el.classList.toggle("n0", c===0 && !isOn(el.dataset.p,el.dataset.v));
    });
  });
}
function schedule(){ clearTimeout(timer); timer=setTimeout(refresh,300); }
async function refresh(){
  const n=++seq;
  if(!SECTION){ setGo(null); return; }
  const qs=buildQS();
  foot.classList.add("busy");
  try{
    const url=location.pathname+"?"+(qs?qs+"&":"")+"section_id="+encodeURIComponent(SECTION);
    const html=await (await fetch(url,{credentials:"same-origin"})).text();
    if(n!==seq) return;
    const doc=new DOMParser().parseFromString(html,"text/html");
    const sec=doc.querySelector("#dl-collection");
    const fresh=doc.querySelector("#dl-filter-data");
    if(fresh){ try{ paintCounts(JSON.parse(fresh.textContent)); }catch(e){} }
    setGo(sec?parseInt(sec.dataset.total,10):null);
  }catch(e){
    if(n===seq) setGo(null);          // network hiccup: fall back to the plain label
  }finally{
    if(n===seq) foot.classList.remove("busy");
  }
}

/* ---------------- staged-state → UI ---------------- */
function sync(){
  $$("[data-p]",dr).forEach(el=>el.classList.toggle("on",isOn(el.dataset.p,el.dataset.v)));
  /* per-group marker, so a group pulling its weight is visible at a glance */
  $$(".fgrp",dr).forEach(el=>{
    const g=data[+el.dataset.grp]; if(!g) return;
    let n=0;
    if(g.type==="price_range") n=(price.gte||price.lte)?1:0;
    else{ const s=sel.get(g.param); n=s?(isCct(g)?(s.size===g.values.length?0:1):chipCount(g.param,s)):0; }
    el.classList.toggle("sel",n>0);
    const gn=$(".gn",el); if(gn) gn.textContent=n||"";
  });
  foot.classList.toggle("dirty",dirty());
  const n=stagedCount();
  dr.classList.toggle("hasfilters",n>0);
  const c=$(".clr",dr); if(c) c.disabled=!n;
}
function toggle(param,value){
  const s=setOf(param), rs=rawsOf(param,value), on=rs.some(r=>s.has(r));
  rs.forEach(r=>{ if(on) s.delete(r); else s.add(r); });
  if(!s.size) sel.delete(param);
  sync(); schedule();
}

dr.addEventListener("click",e=>{
  const el=e.target.closest("[data-p]");
  if(!el||!dr.contains(el)) return;
  e.preventDefault();
  toggle(el.dataset.p,el.dataset.v);
});

/* price inputs — staged like everything else */
if(PRICE){
  const gte=$('input[name="'+PRICE.param+'.gte"]',dr), lte=$('input[name="'+PRICE.param+'.lte"]',dr);
  const read=()=>{ price={gte:gte&&gte.value?gte.value:"",lte:lte&&lte.value?lte.value:""}; sync(); schedule(); };
  [gte,lte].forEach(i=>i&&i.addEventListener("input",read));
  resetters.push(()=>{ if(gte)gte.value=PRICE.min||""; if(lte)lte.value=PRICE.max||""; });
  clearers.push(()=>{ if(gte)gte.value=""; if(lte)lte.value=""; });
}

/* --- CCT gradient dual-slider — stages a range, never navigates --- */
$$(".cct",dr).forEach(el=>{
  const g=data[+el.dataset.cct];
  const stops=g.values.map(v=>({k:kelvinOf(v.v||v.l),val:String(v.v||v.l),active:v.active})).filter(s=>s.k!=null).sort((a,b)=>a.k-b.k);
  const N=stops.length; if(N<2){el.closest(".fgrp").remove();return;}
  const actIdx=stops.map((s,i)=>s.active?i:-1).filter(i=>i>-1);
  const seedMin=actIdx.length?Math.min(...actIdx):0, seedMax=actIdx.length?Math.max(...actIdx):N-1;
  let minIdx=seedMin, maxIdx=seedMax;
  const grad=stops.map((s,i)=>cctColor(s.k)+" "+(i/(N-1)*100).toFixed(2)+"%").join(", ");
  el.innerHTML='<div class="dlcct-ro"></div><div class="dlcct-tw"><div class="dlcct-track" style="background:linear-gradient(90deg, '+grad+')"> </div><div class="dlcct-veil dlcct-veil-l"> </div><div class="dlcct-veil dlcct-veil-r"> </div><button type="button" class="dlcct-thumb dlcct-thumb-min" aria-label="Minimální teplota"></button><button type="button" class="dlcct-thumb dlcct-thumb-max" aria-label="Maximální teplota"></button></div><div class="dlcct-scale"><span>'+stops[0].k+' K</span><span>'+stops[N-1].k+' K</span></div>';
  const tw=$(".dlcct-tw",el), vl=$(".dlcct-veil-l",el), vr=$(".dlcct-veil-r",el), tmin=$(".dlcct-thumb-min",el), tmax=$(".dlcct-thumb-max",el), ro=$(".dlcct-ro",el);
  const pct=i=>i/(N-1)*100;
  function paint(){
    tmin.style.left=pct(minIdx)+"%"; tmax.style.left=pct(maxIdx)+"%";
    vl.style.width=pct(minIdx)+"%"; vr.style.width=(100-pct(maxIdx))+"%";
    ro.innerHTML=(minIdx===0&&maxIdx===N-1)
      ? '<strong>Vše</strong><span class="sub">'+stops[0].k+'–'+stops[N-1].k+' K</span>'
      : stops[minIdx].k+' K <span class="sub">–</span> '+stops[maxIdx].k+' K';
  }
  function stage(){
    const full=(minIdx===0&&maxIdx===N-1);
    if(full) sel.delete(g.param);
    else sel.set(g.param,new Set(stops.slice(minIdx,maxIdx+1).map(s=>s.val)));
    sync(); schedule();
  }
  function idxFromX(x){
    const r=tw.getBoundingClientRect();
    const p=Math.max(0,Math.min(1,r.width?(x-r.left)/r.width:0));
    return Math.round(p*(N-1));
  }
  let dragging=null;
  function onMove(e){ if(!dragging)return; const i=idxFromX(e.clientX);
    if(dragging==="min") minIdx=Math.min(i,maxIdx); else maxIdx=Math.max(i,minIdx); paint(); }
  function onUp(){ if(!dragging)return; dragging=null;
    document.removeEventListener("pointermove",onMove); document.removeEventListener("pointerup",onUp); stage(); }
  const start=w=>e=>{ e.preventDefault(); e.stopPropagation(); dragging=w;
    document.addEventListener("pointermove",onMove); document.addEventListener("pointerup",onUp); };
  tmin.addEventListener("pointerdown",start("min"));
  tmax.addEventListener("pointerdown",start("max"));
  tw.addEventListener("pointerdown",e=>{
    if(e.target===tmin||e.target===tmax) return;
    const i=idxFromX(e.clientX);
    if(Math.abs(i-minIdx)<=Math.abs(i-maxIdx)) minIdx=Math.min(i,maxIdx); else maxIdx=Math.max(i,minIdx);
    paint(); stage();
  });
  resetters.push(()=>{ minIdx=seedMin; maxIdx=seedMax; paint(); });
  clearers.push(()=>{ minIdx=0; maxIdx=N-1; paint(); });
  paint();
});

/* ---------------- open / close / apply ---------------- */
const btn=$("#dl-filters-open");
const appliedCount=stagedCount();
if(appliedCount){ btn.classList.add("has"); $(".bn",btn).textContent=appliedCount; }

btn.setAttribute("aria-expanded","false");
function open(){
  dr.classList.add("open"); btn.setAttribute("aria-expanded","true");
  sync(); setGo(APPLIED_TOTAL); if(dirty()) schedule();
  /* if the toolbar has already scrolled past, bring the panel back into view —
     140px of slack so the sticky header does not sit on top of its first row */
  const t=dr.getBoundingClientRect().top;
  if(t<140||t>innerHeight-120) scrollTo({top:Math.max(0,t+scrollY-140),behavior:"smooth"});
}
function close(){
  dr.classList.remove("open"); btn.setAttribute("aria-expanded","false");
  /* unapplied choices are discarded — the panel always mirrors the grid */
  clearTimeout(timer); seq++;
  seed(); resetters.forEach(f=>f());
  paintCounts(data); sync(); setGo(APPLIED_TOTAL); foot.classList.remove("busy");
}
function apply(){
  if(!dirty()){ close(); return; }
  const qs=buildQS();
  go.textContent="Načítám…"; go.disabled=true;
  location.href=location.pathname+(qs?"?"+qs:"");
}
btn.addEventListener("click",()=>{ dr.classList.contains("open")?close():open(); });
$(".x",dr).addEventListener("click",close);
$(".clr",dr).addEventListener("click",()=>{
  sel.clear(); price={gte:"",lte:""};
  clearers.forEach(f=>f());
  sync(); schedule();
});
go.addEventListener("click",apply);
document.addEventListener("keydown",e=>{ if(e.key==="Escape"&&dr.classList.contains("open")) close(); });
sync();
})();
